// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { css } from "styled-components";

export const headerText: TypographyPresentationProps = {
    variant: "h6",
    transform: "uppercase",
    color: "text",
};

export const linkStyles: LinkPresentationProps = {
    typographyProps: {
        ...fontConfig.xSmallSingleLine,
    },
    css: css`
        ${TypographyStyle} {
            font-weight: ${fontConfig.weight.regular};
            line-height: ${fontConfig.xSmallSingleLine.lineHeight};
        }
    `,
};

export const focusedLinkStyles: LinkPresentationProps = {
    typographyProps: {
        ...fontConfig.xSmallSingleLine,
        color: "common.ui11"
    },
};

export const itemText: TypographyPresentationProps = {
    ...fontConfig.xSmallSingleLine,
    weight: fontConfig.weight.regular,
    css: css`
        ${TypographyStyle},span > b {
            font-weight: ${fontConfig.weight.regular};
            line-height: ${fontConfig.xSmallSingleLine.lineHeight};
        }
    `,
};
export const focusedItemText: TypographyPresentationProps = {
    ...fontConfig.xSmallSingleLine,
    weight: fontConfig.weight.bold,
    css: css`
        &&& {
            ${TypographyStyle}, span > b {
                font-weight: ${fontConfig.weight.bold};
                line-height: ${fontConfig.xSmallSingleLine.lineHeight};
            }
        }
    `,
};
